import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useMobileMenuReset } from "../../Utils/useMobileMenuReset";

function HeaderArea() {
  // Use the custom hook to automatically reset mobile menu on navigation
  useMobileMenuReset();
  // Ensure smooth open/close via Bootstrap Collapse and close on outside click
  useEffect(() => {
    const collapseEl = document.getElementById('lawgisNav');
    const toggler = document.querySelector('.header-area.style-two .navbar-toggler');
    const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;

    if (!collapseEl || !CollapseCtor) return;

    const collapse = CollapseCtor.getOrCreateInstance(collapseEl, { toggle: false });

    const handleOutsideClick = (event) => {
      const navbar = document.querySelector('.header-area.style-two .navbar');
      if (!navbar || !collapseEl.classList.contains('show')) return;
      if (!navbar.contains(event.target)) {
        collapse.hide();
      }
    };

    // Close on any nav link click inside this header
    const navLinks = document.querySelectorAll('.header-area.style-two .navbar-nav a, .header-area.style-two .navbar-nav .magnet-link');
    const handleNavLinkClick = () => collapse.hide();
    navLinks.forEach(link => link.addEventListener('click', handleNavLinkClick));

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
      navLinks.forEach(link => link.removeEventListener('click', handleNavLinkClick));
    };
  }, []);
  return (
    <div>
      <header className="header-area style-two">
        <div className="header-top">
          <div className="container h-100 d-flex align-items-center justify-content-between">
            <div className="left-side d-flex align-items-center gap-4 gap-lg-5">
              <div className="d-flex align-items-center gap-2 text-white">
                <i className="ti ti-phone"></i>
                <span className="d-none d-md-block">0-869-878-08-68</span>
              </div>
              <div className="d-flex align-items-center gap-2 text-white">
                <i className="ti ti-mail"></i>
                <span className="d-none d-md-block">info@paraclearth.com</span>
              </div>
            </div>

            <div className="right-side">
              <div className="d-flex align-items-center gap-2 text-white">
                <i className="ti ti-map-pin"></i>
                <span className="d-none d-md-block">
                  2774 Oak Drive, Plattsburgh, New York
                </span>
              </div>
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Navbar Brand */}
            <Link className="navbar-brand" to="/">
              <img src="assets/img/core-img/logo-light.png" alt="" />
            </Link>

            {/* Navbar Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              aria-controls="lawgisNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={(e) => {
                const collapseEl = document.getElementById('lawgisNav');
                const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;
                if (!collapseEl || !CollapseCtor) return;
                const collapse = CollapseCtor.getOrCreateInstance(collapseEl, { toggle: false });
                const isOpen = collapseEl.classList.contains('show');
                if (isOpen) {
                  collapse.hide();
                  e.currentTarget.setAttribute('aria-expanded', 'false');
                } else {
                  collapse.show();
                  e.currentTarget.setAttribute('aria-expanded', 'true');
                }
              }}
            >
              <i className="ti ti-category"></i>
            </button>

            {/* Navbar Nav */}
            <div
              className="collapse navbar-collapse justify-content-between"
              id="lawgisNav"
            >
              <ul className="navbar-nav navbar-nav-scroll">
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Home <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/">
                        Home One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/hometwo">
                        Home Two
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homethree">
                        Home Three
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homefour">
                        Home Four
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/homefive">
                        Home Five
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Pages <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="/aboutus">
                        About Us
                      </Link>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Service <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/service">
                            Service
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/servicedetails">
                            Service Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Case Studies <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/casestudy">
                            Case Study
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/casestudydetails">
                            Case Study Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="lawgis-dd">
                      <Link className="magnet-link" to="#">
                        Team <i className="ti ti-chevron-right"></i>
                      </Link>
                      <ul className="lawgis-dd-menu">
                        <li>
                          <Link className="magnet-link" to="/team">
                            Team
                          </Link>
                        </li>
                        <li>
                          <Link className="magnet-link" to="/teamdetails">
                            Team Details
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/pricing">
                        Pricing Plan
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/faq">
                        FAQ
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/pagenotfound">
                        404 - Error
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link className="magnet-link" to="/casestudy">
                    Case Studies
                  </Link>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Blog <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/blogone">
                        Blog One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/blogtwo">
                        Blog Two
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/blogdetails">
                        Blog Details
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link className="magnet-link" to="#">
                    Contact <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link className="magnet-link" to="/blogone">
                        Contact One
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="/contacttwo">
                        Contact Two
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>

              <div className="d-flex align-items-center">
                {/* Search Button */}
                <div className="header-search-btn" id="searchButton">
                  <button className="btn text-dark">
                    <i className="ti ti-search"></i>
                  </button>
                </div>

                {/* Button */}
                <Link to="/blogone" className="btn btn-primary">
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default HeaderArea;
